import { render } from "./IngresosMensualesBorrador.vue?vue&type=template&id=935f0684"
import script from "./IngresosMensualesBorrador.vue?vue&type=script&lang=js"
export * from "./IngresosMensualesBorrador.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__